import { serializeSuperjson } from '@lib/superjson';
import {
  SendSnapQuoteOutput,
  SendSnapQuoteRequest,
  SendSnapQuoteRequestParams,
} from '@snap-types/actions/send-snap-quote';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const SEND_SNAP_QUOTE_MUTATION_KEY = 'sendSnapQuote';

export const [sendSnapQuote, useSendSnapQuoteMutation] = injectMutation<
  SendSnapQuoteRequestParams & SendSnapQuoteRequest,
  SendSnapQuoteOutput
>(
  `${QUOTE_BUILDER_SLICE_NAME}/sendSnapQuote`,
  ({ snapQuoteUuid, siteCode, sendEmailToCustomer, quotePdfBase64 }) => ({
    url: buildSnapQuoteUrl(siteCode, snapQuoteUuid, 'send'),
    method: 'POST',
    body: serializeSuperjson({
      sendEmailToCustomer,
      quotePdfBase64,
    }),
  }),
);
